import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { crmConstants, crmModels } from '..';

export const useLeadTaskTypeAll = (props: { enabled?: boolean } = {}) =>
  useQuery<crmModels.ILeadTaskType[]>({
    queryKey: [crmConstants.queryKeys.LEAD_TASK_TYPE_ALL],
    queryFn: async () => {
      const res = await $api.get('/v1/lead-task-type/all');

      return res?.data?.data;
    },
    enabled: props?.enabled
  });
